import React from "react"
import { createRoot } from "react-dom/client"
import App from "./App"
import "../../styles/main.css"
import { I18nextProvider } from "react-i18next"
import { Provider } from "react-redux"
import { store } from "../../app"
import SearchLayout from "../../shared/Layouts/SearchLayout"

const mountApp = () => {
  const node = document.getElementById("transfer-price-form-react")
  if (!node || node.dataset.mounted) return

  const i18n = window.i18n
  if (!i18n) {
    window.addEventListener("i18n:ready", mountApp, { once: true })
    return
  }

  node.dataset.mounted = "true"

  const props = JSON.parse(node.getAttribute("data-props") || "{}")

  // if (!props.priceId && !props.prefill?.from_id) {
  //   const q = new URLSearchParams(window.location.search)
  //   const prefill = Object.fromEntries(
  //     ["from_id", "transport_type_id", "copy"].map((k) => [k, q.get(k)]).filter(([, v]) => v)
  //   )
  //   if (Object.keys(prefill).length) props.prefill = prefill
  // }

  if (props.locale) {
    i18n.changeLanguage(props.locale)
  }

  const root = createRoot(node)
  root.render(
    <Provider store={store}>
      <I18nextProvider i18n={i18n}>
        <SearchLayout themeName={props?.themeName ?? "default"} isAdmin={props?.isAdmin}>
          <App {...props} />
        </SearchLayout>
      </I18nextProvider>
    </Provider>
  )
}

document.addEventListener("DOMContentLoaded", mountApp)
document.addEventListener("turbolinks:load", mountApp)
